// extracted by mini-css-extract-plugin
export default {"wrap":"Checkbox_wrap__YEMto","wrap_radio":"Checkbox_wrap_radio__pUYVk","icon":"Checkbox_icon__Xjbrs","input":"Checkbox_input__KAVVD","name":"Checkbox_name__WTtW+"};